export default __webpack_public_path__ + "static/1-3a19bf24cf1b19751178df2400a7e5ac.jpg";